import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "../components/layout/layout";
import LayoutSec from "../components/layout/layoutSec";
import Index from "../pages/index";
import Login from "../pages/login/loginPage";
import LoginMemberPage from "../pages/contents/daolInv/consentRMF/loginMember";
import ConsentPage from "../pages/contents/daolInv/consentRMF/consent";
import OtpPage from "../pages/contents/daolInv/consentRMF/otp";
import FinishedPage from '../pages/contents/daolInv/consentRMF/finish';
import LoginKycPage from "../pages/contents/daolSec/kyc/loginKyc";
import LoginDateKycPage from "../pages/contents/daolSec/kyc/loginDate";
import LoginReviewSuitAndKycPage from "../pages/contents/daolInv/reviewSuitAndKyc/loginekyc";
import LoginDateReviewSuitAndKycPage from "../pages/contents/daolInv/reviewSuitAndKyc/loginDate";
import OtpReviewSuitAndKycPage from "../pages/contents/daolInv/reviewSuitAndKyc/otp";
import OtpKycPage from "../pages/contents/daolSec/kyc/otp";
import ConsentBackInformationPage from "../pages/contents/daolInv/consentRMF/consentBackInformation";
import ConsentSelectPage from "../pages/contents/daolInv/consentRMF/consentSelect";
import LoginNdidInvPage from "../pages/contents/daolInv/saNdid/loginNdid";
import OtpNdidPage from "../pages/contents/daolInv/saNdid/otp";
import LoginNdidSecPage from "../pages/contents/daolSec/saNdid/loginNdid";
import OtpNdidSecPage from "../pages/contents/daolSec/saNdid/otp";
import OtpNdidInvPage from "../pages/contents/daolInv/saNdid/otp";
import LoginClassifyPage from "../pages/contents/daolSec/classify/loginClassify";
import LoginDateClassifyPage from "../pages/contents/daolSec/classify/loginDate";
import OtpClassifyPage from "../pages/contents/daolSec/classify/otp";


const Routes = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/" exact>
          <Login />
        </Route>
        <Route path="/home">
          <LayoutSec>
          <Index />
          </LayoutSec>
        </Route>
        <Route path="/contents/daolInv/consentRMF/loginMember" exact>
          <Layout>
            <LoginMemberPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/consentRMF/otp" exact>
          <Layout>
            <OtpPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/consentRMF/consentSelect" exact>
          <Layout>
            <ConsentSelectPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/consentRMF/consent" exact>
          <Layout>
            <ConsentPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/consentRMF/consentBackInformation" exact>
          <Layout>
            <ConsentBackInformationPage />
          </Layout>
        </Route>

        
        <Route path="/contents/daolInv/consentRMF/finish" exact>
          <Layout>
            <FinishedPage />
          </Layout>
        </Route>
        
        {/* ------------------------------------------------------ KYC Project --------------------------------------------------- */}
        <Route path="/contents/daolSec/kyc/loginKyc" exact>
          <Layout>
            <LoginKycPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/kyc/loginDate" exact>
          <Layout>
            <LoginDateKycPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/kyc/otp" exact>
          <Layout>
            <OtpKycPage />
          </Layout>
        </Route>
        {/* ------------------------------------------------------ Classify Project --------------------------------------------------- */}
        <Route path="/contents/daolSec/classify/loginClassify" exact>
          <Layout>
            <LoginClassifyPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/classify/loginDate" exact>
          <Layout>
            <LoginDateClassifyPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/classify/otp" exact>
          <Layout>
            <OtpClassifyPage />
          </Layout>
        </Route>
        {/* ------------------------------------------------------ INV - NDID Project --------------------------------------------------- */}
        <Route path="/contents/daolInv/saNdid/loginNdid" exact>
          <Layout>
            <LoginNdidInvPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/saNdid/otp" exact>
          <Layout>
            <OtpNdidPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/saNdid/loginNdid" exact>
          <Layout>
            <LoginNdidSecPage />
          </Layout>
        </Route>
        <Route path="/contents/daolSec/saNdid/otp" exact>
          <Layout>
            <OtpNdidSecPage />
          </Layout>
        </Route>

        {/* ----------------------------------------- INV - EKYC (suit & kyc) Project ---------------------------------------- */}
        <Route path="/contents/daolInv/reviewSuitAndKyc/loginekyc" exact>
          <Layout>
            <LoginReviewSuitAndKycPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/reviewSuitAndKyc/loginDate" exact>
          <Layout>
            <LoginDateReviewSuitAndKycPage />
          </Layout>
        </Route>
        <Route path="/contents/daolInv/reviewSuitAndKyc/otp" exact>
          <Layout>
            <OtpReviewSuitAndKycPage />
          </Layout>
        </Route>
      </Switch>
    </Router>
  );
};
export default Routes;
